import React from 'react';
import Card from '../Card/Card';
import RepeatingFields from '../RepeatingFields/RepeatingFields';
import AddressItem from '../AddressItem/AddressItem';

const AddressMKD = ({ form }) => {
  return (
    <Card heading="Адрес МКД">
      <RepeatingFields
        form={form}
        formKey={'addressKeys'}
        addButtonText="Добавить адрес"
        renderOneItem={(index, allowDelete, deleteItem) => (
          <AddressItem
            form={form}
            index={index}
            allowDelete={allowDelete}
            deleteItem={deleteItem}
          />
        )}
        style={{ gap: '25px' }}
      />
    </Card>
  );
};

export default AddressMKD;
